import React, { useEffect, useState } from 'react'
import { Elements } from '@stripe/react-stripe-js'

import { loadStripe, Stripe } from '@stripe/stripe-js'
import Payment from '../components/Payment'
import { getSharedConfig } from '../get-config'
import SkeletonPayment from '../components/Payment/Skeletons/SkeletonPayment'

const PaymentScreen = () => {
  const [stripe, setStripe] = useState<Promise<Stripe | null>>()

  useEffect(() => {
    setStripe(loadStripe(getSharedConfig().STRIPE_API_PUBLISHABLE_KEY))
  }, [])

  return stripe ? (
    <Elements stripe={stripe}>
      <Payment />
    </Elements>
  ) : (
    <SkeletonPayment />
  )
}

export default PaymentScreen
